import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const features = ['100+ Roboter-Projekte', 'Einfache Alltagsmaterialien', 'Schritt-für-Schritt PDF-Anleitungen', 'Keine Vorkenntnisse nötig', 'Perfekt für 4–12 Jahre', 'Sofortiger digitaler Download'];
const floatingBadges = [{
  label: '🤖 Echte Roboter bauen',
  pos: 'left-4 top-4 sm:-left-4'
}, {
  label: '🧠 Fördert MINT-Fähigkeiten',
  pos: 'right-4 top-16 sm:-right-6'
}, {
  label: '📄 PDF-Anleitungen',
  pos: 'left-4 bottom-24 sm:-left-6'
}, {
  label: '📦 100+ Projekte',
  pos: 'right-4 bottom-6 sm:-right-4'
}];
const avatars = [{
  letter: 'J',
  color: 'bg-brand'
}, {
  letter: 'S',
  color: 'bg-emerald-500'
}, {
  letter: 'M',
  color: 'bg-blue-500'
}, {
  letter: 'R',
  color: 'bg-amber-500'
}];
export function Hero() {
  return <section className="w-full overflow-hidden bg-cream" data-id="element-67">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-14 sm:px-6 md:py-20 lg:grid-cols-2 lg:gap-16" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-69">
          <p className="mb-5 flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-70">
            <span className="h-px w-8 bg-brand" aria-hidden="true" data-id="element-71" />
            100+ Roboter-Projekte für Kinder
          </p>
          <h1 className="font-display text-4xl font-black leading-[1.05] text-ink sm:text-5xl md:text-6xl" data-id="element-72">
            Halte deine Kinder{' '}
            <span className="italic text-brand" data-id="element-73">weg vom Bildschirm</span> — mit
            Robotik!
          </h1>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-ink/60" data-id="element-74">
            Spaß, der{' '}
            <strong className="text-ink" data-id="element-75">wirklich etwas beibringt</strong>. Mit
            einfachen Alltagsmaterialien und Schritt-für-Schritt-PDF-Anleitungen
            lernt, spielt und wächst dein Kind — fernab von Bildschirmen.
          </p>

          <div className="mt-8 flex items-center gap-4" data-id="element-76">
            <div className="flex -space-x-2" data-id="element-77">
              {avatars.map(a => <span key={a.letter} className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-cream text-sm font-bold text-white ${a.color}`} data-id="element-78">
                  {a.letter}
                </span>)}
            </div>
            <div data-id="element-79">
              <div className="flex text-amber-400" aria-hidden="true" data-id="element-80">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-81" />)}
              </div>
              <p className="text-sm text-ink/60" data-id="element-82">
                <strong className="text-ink" data-id="element-83">2.000+ Familien</strong> bauen
                bereits gemeinsam
              </p>
            </div>
          </div>

          <ul className="mt-8 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-84">
            {features.map(f => <li key={f} className="flex items-center gap-2.5 text-sm font-semibold text-ink" data-id="element-85">
                <span className="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-light text-brand" data-id="element-86">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-87" />
                </span>
                {f}
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-88">
            <CtaButton data-id="element-89">Ja! Ich will MakerLab</CtaButton>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-90">
          <div className="relative overflow-hidden rounded-[2rem] bg-ink shadow-2xl" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/bdce1584-127d-49e6-8205-c7122adc97ef.jpg" alt="Zwei Kinder bauen gemeinsam Roboter aus Karton mit MakerLab" className="h-full w-full object-cover" data-id="element-92" />
          </div>
          {floatingBadges.map(b => <motion.div key={b.label} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.5
        }} className={`absolute rounded-full bg-white px-3.5 py-2 text-xs font-bold text-ink shadow-lg ${b.pos}`} data-id="element-93">
              {b.label}
            </motion.div>)}
        </motion.div>
      </div>
      <div className="h-2 w-full bg-brand" aria-hidden="true" data-id="element-94" />
    </section>;
}